import React, { useState } from "react";
import { ChevronLeft, ChevronRight, FileText } from "lucide-react";

const getFileName = (url = "") => {
  try {
    const decoded = decodeURIComponent(String(url).split("?")[0]);
    return decoded.substring(decoded.lastIndexOf("/") + 1) || "Attachment";
  } catch (e) {
    return "Attachment";
  }
};

const getExtension = (url = "") => {
  const name = getFileName(url);
  const dot = name.lastIndexOf(".");
  return dot > -1 ? name.slice(dot + 1).toLowerCase() : "";
};

const isImage = (url) => ["png", "jpg", "jpeg", "gif", "webp", "bmp"].includes(getExtension(url));

const arrowStyle = (enabled) => ({
  width: "28px",
  height: "28px",
  borderRadius: "50%",
  border: "1px solid #D0D5DD",
  background: "#fff",
  color: "#2E6DA4",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  cursor: enabled ? "pointer" : "default",
  opacity: enabled ? 1 : 0.35,
  padding: 0,
});

// Shows attachments as tiles side by side; when there are more than
// `visibleCount`, the < > arrows step through the rest.
const AttachmentGallery = ({ urls = [], onOpen, visibleCount = 3, tileWidth = 120, tileHeight = 90 }) => {
  const [start, setStart] = useState(0);
  if (!urls.length) return null;

  const shown = Math.min(visibleCount, urls.length);
  const maxStart = urls.length - shown;
  const canPrev = start > 0;
  const canNext = start < maxStart;
  const visible = urls.slice(start, start + shown);
  const showArrows = urls.length > shown;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      {showArrows && (
        <button type="button" title="Previous" disabled={!canPrev} onClick={() => setStart((s) => Math.max(s - 1, 0))} style={arrowStyle(canPrev)}>
          <ChevronLeft size={16} />
        </button>
      )}
      <div style={{ display: "flex", gap: "8px" }}>
        {visible.map((url) => {
          const ext = getExtension(url);
          return (
            <div
              key={url}
              title={getFileName(url)}
              onClick={() => onOpen && onOpen(url)}
              style={{
                width: `${tileWidth}px`, height: `${tileHeight}px`, borderRadius: "8px", border: "1px solid #E4E7EC",
                overflow: "hidden", cursor: "pointer", background: "#F9FAFB", display: "flex",
                alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "4px", flexShrink: 0,
              }}
            >
              {isImage(url) ? (
                <img src={url} alt={getFileName(url)} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              ) : (
                <>
                  <FileText size={28} color="#2E6DA4" />
                  <span style={{ fontSize: "11px", fontWeight: 700, color: "#475467", textTransform: "uppercase" }}>{ext || "file"}</span>
                </>
              )}
            </div>
          );
        })}
      </div>
      {showArrows && (
        <button type="button" title="Next" disabled={!canNext} onClick={() => setStart((s) => Math.min(s + 1, maxStart))} style={arrowStyle(canNext)}>
          <ChevronRight size={16} />
        </button>
      )}
    </div>
  );
};

export default AttachmentGallery;
